/* unplugin-vue-components disabled */import { render } from "./advantageCom.vue?vue&type=template&id=012ea39a&scoped=true"
import script from "./advantageCom.vue?vue&type=script&lang=js"
export * from "./advantageCom.vue?vue&type=script&lang=js"

import "./advantageCom.vue?vue&type=style&index=0&id=012ea39a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.15_webpack@5.89.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-012ea39a"]])

export default __exports__